import { includes } from 'lodash';
import { FlowNode } from '../flowState';
import { ZT_LIVE_DATA_SERVICES } from 'app/beta-editor/constants';

// !!! IMPORTANT !!!
// This function affects the global flows redux state. You
// may need to make the same changes to both the beta-editor
// and classic-editor code. Edit with caution and test thoroughly.
const requiresLiveData = (node?: FlowNode) => {
  return Boolean(node && includes(ZT_LIVE_DATA_SERVICES, node.selected_api));
};

export default requiresLiveData;
